import { PROJECT_INVALIDATE_GET_PROJECTS_CACHE } from './actionTypes';
import { takeEvery } from 'redux-saga/effects';
import { RealtimeMessage } from '../../entities/RealtimeMessages';
import { ServiceList } from '../../services/serviceList';

export default function* watchInvalidateGetProjectsCache() {
	yield takeEvery(PROJECT_INVALIDATE_GET_PROJECTS_CACHE, invalidateGetProjectsCache);
}

function* invalidateGetProjectsCache(
	action: RealtimeMessage<typeof PROJECT_INVALIDATE_GET_PROJECTS_CACHE>
) {
	ServiceList.Studio.ProjectManager.GetProjects.invalidateCache();
}
